import { mutationTypes } from './types';

const mutations = {
  [mutationTypes.SET_SCHOOLS](state, payload) {
    state.schools = payload;
  },
  [mutationTypes.SET_SCHOOL_TYPES](state, payload) {
    state.schoolTypes = payload;
  },
  [mutationTypes.SET_MUNICIPALITIES](state, payload) {
    state.municipalities = payload;
  },
  [mutationTypes.SET_RLVTYPES](state, payload) {
    state.rlvTypes = payload;
  },
  [mutationTypes.SET_SCHOOL_INFORMATION](state, payload) {
    state.schoolInformation = payload;
  },
  [mutationTypes.SET_FILTER](state, payload) {
    state.filter = {
      ...payload,
      schoolType: payload.schoolType,
    };
  },
  [mutationTypes.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [mutationTypes.SET_RESULTS](state, payload) {
    state.results = payload.data;
    state.pagination.totalItemCount = payload.totalItemCount;
    state.pagination.currentPage = payload.currentPage;
    state.pagination.pageCount = payload.pageCount;
  },
  [mutationTypes.CLEAN_SCHOOL](state) {
    state.filter.schoolName = null;
  },
};

export default mutations;
